import { Pipe, PipeTransform } from '@angular/core';
import { DType } from '../../../../shared/models/deposit-rial.model';

@Pipe({
  name: 'depositType'
})
export class DepositTypePipe implements PipeTransform {
  transform(value: DType, ...args: unknown[]): string {
    switch (value) {
      case 'card':
        return 'درگاه بانکی';
      case 'iban':
        return 'شناسه‌دار';
    }
    return value;
  }
}
